import { Select } from '@mantine/core'
import { SelectProps } from '@mantine/core'

interface MyComponentProps
    extends Omit<SelectProps & React.RefAttributes<HTMLInputElement>, 'data'> {
    data?: []
    withAll?: boolean
}
const InputPersonType = ({
    withAll = false,
    label = 'ประเภทบุคคล',
    classNames,
    value,
    styles,
    unstyled,
    className,
    defaultValue,
    ...others
}: MyComponentProps) => {
    const addlist = withAll === true ? [{ value: '', label: 'ทั้งหมด' }] : []

    return (
        <Select
            className={className}
            value={String(value)}
            placeholder='กรอกข้อมูล'
            label={'ประเภทบุคคล'}
            data={[
                ...addlist,
                { value: '1', label: 'พนักงาน' },
                { value: '2', label: 'บุคคลทั่วไป' },
            ]}
            {...others}
        />
    )
}

export default InputPersonType
